import React from "react";

const Footer = function (prop) {
  // Ensure HTTPS for tracking URL so browsers do not block it as Mixed Content
  // When security level is L1, tracking URL is removed so it does not get bound or triggered
  const isL1 =
    prop.isLevelOne === true ||
    prop.securityLevel === "1" ||
    prop.securityLevel === 1 ||
    (typeof prop.securityLevel === "string" && prop.securityLevel.trim().toUpperCase() === "L1") ||
    prop.level === "1" ||
    prop.level === 1 ||
    (typeof prop.level === "string" && prop.level.trim().toUpperCase() === "L1") ||
    prop.rdocsLevel === "1" ||
    prop.rdocsLevel === 1 ||
    (typeof prop.rdocsLevel === "string" && prop.rdocsLevel.trim().toUpperCase() === "L1");
  const secureTrackingUrl = (!isL1 && prop.trackingUrl && prop.trackingUrl.trim()) ? (prop.trackingUrl.trim().startsWith("http://") ? prop.trackingUrl.trim().replace(/^http:\/\//i, "https://") : prop.trackingUrl.trim()) : "";
  return (
    <footer
      className={
        (prop.class === undefined ? "" : prop.class) +
        ((prop.Reader_GeneralTermsFooter != undefined && prop.Reader_GeneralTermsFooter != "") ? " footer mt-auto py-2 bg-lighter rpd-footer" : "")
      }
    >
      {(prop.Reader_GeneralTermsFooter != undefined && prop.Reader_GeneralTermsFooter != "") &&
        <div className="container-fluid rpdFont">
          <p
            className="mb-0"
            style={{ textAlign: "center", fontSize: 0.78 + "rem" }}
          >
            {secureTrackingUrl ? (
              <a href={secureTrackingUrl} target="_blank" rel="noopener noreferrer" title="RPost"
                style={{ textDecoration: "none", display: "inline-block", marginRight: "6px", verticalAlign: "middle" }}
              >
                <img src={secureTrackingUrl} alt="RPost" style={{ height: "1px", width: "1px", verticalAlign: "middle", border: 0 }} />
              </a>
            ) : null}
            <a
              className="footerLinks"
              href="https://rpost.com/legal-notices/terms-and-conditions/" target="_blank"
            >
              {prop.Reader_GeneralTermsFooter + ((prop.Reader_GeneralTermsFooter != undefined && prop.Reader_GeneralTermsFooter != "") ? " & " : "")}  {prop.Reader_LegalNotices}
            </a>
            {((prop.Reader_ClickServiceLevelTerms != undefined && prop.Reader_ClickServiceLevelTerms != "") ? ": " : "") + prop.Reader_ClickServiceLevelTerms + " "}
            <a
              className="footerLinks"
              href="https://rpost.com/legal-notices/legal-and-patent-notice/" target="_blank"
            >
              {prop.Reader_Patent}
            </a>
            {((prop.Reader_OtherService != undefined && prop.Reader_OtherService != "") ? ", " : "") + prop.Reader_OtherService}
          </p>
        </div>
      }
    </footer>
  );
};
export default Footer;
